import React, { memo } from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'

import { LocationsSelectInput, Txt, DatePicker } from '../../../../../components'
import InputFormik from '../../../../../components/InputFormik'
import styles from './styles'
import { ScrollView } from 'react-native-gesture-handler'
import moment from 'moment'

const CapacityFrom = ({ formikParams }) => {
  const { values, setFieldValue, errors, touched } = formikParams

  const parseToDateFormat = (date) => {
    return moment(date).format('YYYY-MM-DD hh:mm:ss')
  }

  return (
    <ScrollView style={styles.container}>
      <View>
        <View>
          <LocationsSelectInput
            name='origin'
            placeholder='Origin'
            selected={values?.origin || ''}
            onChange={setFieldValue}
            error={touched.origin && errors.origin}
            origin
            style={styles.location}
          />
        </View>
        <View>
          <LocationsSelectInput
            name='destination'
            placeholder='Destination'
            selected={values?.destination || ''}
            onChange={setFieldValue}
            error={touched.destination && errors.destination}
            destination
            style={styles.location}
          />
        </View>
      </View>
      <View style={styles.row}>
        <View style={styles.leftItem}>
          <DatePicker
            name='start_date'
            placeholder='Start Date'
            value={values?.start_date ? values.start_date.date : null}
            onChange={(_, value) => setFieldValue('start_date.date', parseToDateFormat(value))}
            error={touched?.start_date?.date && errors?.start_date?.date}
            disablePast
          />
        </View>
        <View style={styles.rightItem}>
          <DatePicker
            name='end_date'
            placeholder='End Date'
            value={values?.end_date ? values.end_date.date : null}
            onChange={(_, value) => setFieldValue('end_date.date', parseToDateFormat(value))}
            error={touched?.end_date?.date && errors?.end_date?.date}
            disablePast
          />
        </View>
      </View>
      <Txt
        text='Dispatcher Information'
        identity='body1'
        color='SLATE_GRAY'
        style={styles.subtitle}
      />
      <View>
        <View>
          <InputFormik
            name='contact_name'
            placeholder='Name'
            letfIcon='User'
            value={values?.contact_name || ''}
            onChange={setFieldValue}
            testID='recurringTractorFormNameInput'
            accessibilityLabel='recurringTractorFormNameInput'
          />
        </View>
        <View>
          <InputFormik
            name='contact_email'
            placeholder='Email'
            letfIcon='Email'
            value={values?.contact_email || ''}
            onChange={setFieldValue}
            error={touched.contact_email && errors.contact_email}
            keyboardType='email-address'
            testID='recurringTractorFormEmailInput'
            accessibilityLabel='recurringTractorFormEmailInput'
          />
        </View>
      </View>
      <View>
        <View>
          <InputFormik
            name='contact_phone'
            placeholder='Phone'
            letfIcon='Phone'
            value={values?.contact_phone || ''}
            error={touched.contact_phone && errors.contact_phone}
            onChange={setFieldValue}
            testID='recurringTractorFormPhoneInput'
            accessibilityLabel='recurringTractorFormPhoneInput'
          />
        </View>
        <View>
          <InputFormik
            name='contact_fax'
            placeholder='Fax'
            letfIcon='Phone'
            value={values?.contact_fax || ''}
            error={touched.contact_fax && errors.contact_fax}
            onChange={setFieldValue}
            testID='recurringTractorFormFaxInput'
            accessibilityLabel='recurringTractorFormFaxInput'
          />
        </View>
      </View>
    </ScrollView>
  )
}

CapacityFrom.propTypes = {
  formikParams: PropTypes.object
}

CapacityFrom.defaultProps = {
  recurringTractor: {},
  onChangeValue: () => {},
  onChangeDate: () => {},
  markRequiredFields: false
}

export default memo(CapacityFrom)
